// SubscriptionPackages only. Shared table methods are in tableMixin.js.
// Methods here with the same name as a tableMixin method replace it on this page.
import axios from "axios";

export default {
    name: "SubscriptionPackages",
    methods: {
        clearForm() {
            this.isEditing = false;
            this.isSaving = false;
            this.submitted = false;
            this.formInputs = this.getDefaultFormInputs(); // every field, incl. features, USD price, trial, switches
            this.$clearValidationStates("#recordForm");
        },
        handleFetchPermissionsSuccess(response) {
            this.permissionOptions = (response.data.results || [])
                .filter((option) => option && option.id !== undefined && option.permission);
        },
        // Delete one plan: explains why a plan in use can't be deleted
        deleteRecord(id) {
            this.$showOrHideLoader(this.tableData.loaderMessage);
            const data = { id, deleteType: this.tableData.deleteType, action: "deleteRecord" };

            axios
                .delete(this.apiUrl, this.$handleConfig(data))
                .then((response) => {
                    if (response.data.status == "success") {
                        this.handleDeleteRecordSuccess(response);
                    } else {
                        this.tableData.isVisible = false;
                        this.handleError("ending", "This plan cannot be deleted. Companies are using it, or it is the sign-up plan. To retire it, untick \"Show to users\".", "danger", "page");
                    }
                })
                .catch((error) => this.handleRequestError(error, "page"));
        },
        // "Delete Selected": some plans may be refused (in use / sign-up plan)
        deleteSelectedRecords() {
            const ids = this.tableData.selectedRecordIds;
            if (!ids.length) {
                this.handleAlert("ending", "No records selected.", "info", "page");
                return;
            }
            if (!confirm(`Are you sure you want to delete ${ids.length} record(s)?`)) return;

            this.$showOrHideLoader(this.$loaderMessages.deleting);
            const data = { action: "deleteRecord", ids, deleteType: "soft" };

            axios
                .delete(this.apiUrl, this.$handleConfig(data))
                .then((response) => {
                    if (response.data.status === "success") {
                        this.handleAlert("ending", this.$loaderMessages.deletingSelectedSuccess, "success", "page");
                        this.tableData.selectedRecordIds = [];
                        this.tableData.selectAll = false;
                    } else {
                        this.handleError("ending", "Some plans were not deleted. Companies are using them, or one is the sign-up plan.", "danger", "page");
                    }
                    this.fetchRecords();
                })
                .catch((error) => this.handleRequestError(error, "page"));
        },
    },
};